/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { Alert, FormGroup, Row, Label, Modal, ModalHeader, ModalBody, Button, Input } from "reactstrap"
import { Controller } from 'react-hook-form'
import Slider from "rc-slider"
import { reportQuestion } from "api/@vp/assess"
import { connect } from "react-redux"
import SweetAlert from 'react-bootstrap-sweetalert'
import { AlertOctagon } from "react-feather"

const CheckField = (props) => {
  const { formRef } = props

  const primary = '#5fb891'
  const secondary = '#dfdfdf'
  const danger = '#ea5455'

  const [slided, updateSlided] = useState(false)

  const defaultRange = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, 10: 10 }
  const submittedRange = { 0: { style: {color: danger}, label: '⚠'}, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, 10: 10 }
  const slidedRange = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, 10: 10 }

  const { reportable, assessmentContext } = props
  const [modalActive, toggleModal] = useState(false)
  const [offenseRadio, toggleRadio] = useState(1)
  const [feedback, updateFeedback] = useState('')
  const [loading, toggleLoading] = useState(false)

  const onReportSubmit = async () => {
    toggleLoading(true)
    await reportQuestion({
      credentials: assessmentContext.reference,
      target: { teams: props.teams, id: props.id, name: props.name, index: props.index },
      reports: { offenseRadio, feedback }
    })
  }

  return (
    <>
      <FormGroup>
        <Label for={props.id} className='form-label'>
          {props.title} <span>{!props.required && '(Optional)'}</span>
          {
            reportable &&
            <a className='form-report' onClick={
              () => toggleModal(true)
            }>
              {' '}<AlertOctagon size={15} className="form-report-text" />
              <span className="form-report-text">{ ' report question'}</span>
            </a>
          }
        </Label>
        <Controller
          name={
            props.index !== undefined && props !== null
              ? `${props.name}[${props.index}]`
              : props.name
          }
          control={formRef.control}
          defaultValue={0}
          render={ctrl => (
            <Row className="mx-2 my-1">
              <Slider
                className={'input-slider'}
                type="slider"
                value={ctrl.value}
                // min={slided ? 1 : 0}
                min={0}
                max={10}
                step={1}
                defaultValue={0}
                onChange={e => {
                  updateSlided(true)
                  ctrl.onChange(e)
                }}
                marks={
                  slided
                    ? slidedRange
                    : (props.required && props.submitTriggered ? submittedRange : defaultRange)
                }
                dotStyle={{borderColor: secondary, width: '17px', height: '17px', transform: 'translate(-25%, 25%)'}}
                trackStyle={props.required && props.submitTriggered && ctrl.value === 0 ? {backgroundColor: danger} : {backgroundColor: primary}}
                activeDotStyle={props.required && props.submitTriggered && ctrl.value === 0 ? {borderColor: danger} : {borderColor: primary}}
                railStyle={{backgroundColor: secondary, height: 5}}
                handleStyle={props.required && props.submitTriggered && ctrl.value === 0 ? {borderColor: danger, backgroundColor: danger} : {borderColor: primary, backgroundColor: primary}}
                style={{color: danger}}
              />
            </Row>
          )}
        />
      </FormGroup>

      {
        reportable &&
        <Modal className="modal-form modal-dialog-centered" isOpen={modalActive} toggle={() => toggleModal(false)}>
          <ModalHeader toggle={() => toggleModal(false)}>Report This Question: {props.title}</ModalHeader>
          <ModalBody className="px-2">
            <Label className='form-label'>Please let us know:</Label>
            <Alert onClick={() => toggleRadio(1)} color={offenseRadio === 1 ? 'primary' : 'secondary'}>
              <div className='alert-body'><span className='font-weight-bold'>This question is not relevant</span></div>
            </Alert>
            <Alert onClick={() => toggleRadio(2)} color={offenseRadio === 2 ? 'primary' : 'secondary'}>
              <div className='alert-body'><span className='font-weight-bold'>This question is inappropriate</span></div>
            </Alert>
            <Alert onClick={() => toggleRadio(3)} color={offenseRadio === 3 ? 'primary' : 'secondary'}>
              <div className='alert-body'><span className='font-weight-bold'>Others</span></div>
            </Alert>
            <Label for={`report-${props.id}`} className='form-label'>Feedback:</Label>
            <Input id={`report-${props.id}`} type={'text'} onChange={(e) => updateFeedback(e.target.value)} />
            <Button className="m-0 mt-1 w-100" color="primary" onClick={onReportSubmit}>Submit</Button>
          </ModalBody>
          {loading &&
            <SweetAlert info showConfirm onConfirm={() => { toggleLoading(false); toggleModal(false); }}>
              <div className="sweet-alert-text">Thank you for your feedback, we will get back to you!</div>
            </SweetAlert>
          }
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => {
  return {
    assessmentContext: state.platform.vp.assessmentContext || state.platform.vt.assessmentContext,
  }
}

export default connect(mapStateToProps)(CheckField)
